import styled from 'styled-components';

import { Modal } from 'antd';

import { COLORS } from 'constants/colors';
import { FONTS, FONTS_WEIGHT } from 'constants/fonts';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    padding: 20px;
  }

  .ant-modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .ant-modal-title {
    font-size: ${FONTS.SUB_HEADER_FONT};
    font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
    line-height: 24px;
    color: ${COLORS.TextBase};
  }

  .ant-modal-body {
    padding-top: 10px;
    height: 572px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${COLORS.BgContainerDisabled};
      border-radius: 9px;
      border: none;
    }
  }

  width: 399px !important;
  height: 572px !important;
`;

export const ReactionListContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  margin: 20px 0;
  flex-wrap: wrap;
`;

export const ReactionItem = styled.div<{ isActive: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px;
  text-transform: capitalize;
  color: ${(props) =>
    props.isActive ? COLORS.Green7 : COLORS.colorTextHeading};
  font-weight: ${(props) => (props.isActive ? 600 : 400)};
  border-bottom: ${(props) => (props.isActive ? '2px solid green' : 'none')};
  transition:
    color 0.3s,
    border-bottom 0.3s;
  margin-right: 16px;

  &:hover {
    color: ${COLORS.Green7};
    border-bottom: 2px solid green;
  }

  & > img {
    margin-right: 8px;
  }
`;

export const UserList = styled.ul`
  margin-top: 20px;
  padding: 0;
  list-style: none;
  max-height: 572px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${COLORS.BgContainerDisabled};
    border-radius: 9px;
    border: none;
  }
`;

export const UserItem = styled.li`
  display: flex;
  align-items: center;
  padding: 16px 0;
  font-size: ${FONTS.TEXT_FONT};
  font-weight: ${FONTS_WEIGHT.TEXT_BOLD};
  line-height: 20px;
  color: ${COLORS.ActiveUserText};
  width: 100%;

  & > div:last-child {
    color: ${COLORS.TextBase};
    border-bottom: 1px solid ${COLORS.ColorSplit};
    padding-bottom: 17px;
    width: 100%;
  }
`;

export const UserIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledIcons = styled.div`
  display: flex;
  margin-right: 10px;
  img {
    padding-top: 26px;
    height: 14px;
    width: 14px;
  }
`;
